class MobileMenuButton {
	constructor(){
		this.btnMobileMenu = document.querySelector('.btn-mobile-menu');
		this.navbar = document.querySelector('.main-header__navbar');
	}

	init(){
		if(this.btnMobileMenu){
			this.btnMobileMenu.addEventListener('click', e => {
				e.preventDefault();
				this.btnMobileMenu.classList.toggle('open');
				this.navbar.classList.toggle('open');
			});
		}
	}
}

export default MobileMenuButton;


// WEBPACK FOOTER //
// ./js/components/MobileMenuButton.js